import isURL from 'validator/es/lib/isURL';
/**
 * @param {Object} oUser
 * @return {String} user full name.
 * @protected
 */
export const getUserName = (oUser) => {
  if (!oUser) {
    return '';
  }

  if (!oUser.firstName && !oUser.lastName) {
    return oUser.email || '';
  }

  let sFullName = oUser.firstName || '';
  if (oUser.lastName) {
    sFullName = sFullName + ' ' + oUser.lastName;
  }
  return sFullName;
}

/**
 * Sort members by name.
 * @param {Array} aMembers - Passed members array.
 * @protected
 */
export const sortMembers = (aMembers) => {
  return aMembers.sort(function (m1, m2) {
    if (!m1.name || !m2.name) {
      return -1
    }

    if (m1.name.toLowerCase() < m2.name.toLowerCase()) {
      return -1;
    }
    if (m1.name.toLowerCase() > m2.name.toLowerCase()) {
      return 1;
    }
    return 0;
  });
}

/**
 * Downloads Given URL imperatively.
 * @param {String} url Url to be download
 */
export const downloadUrl = (url) => {
  var a = document.createElement("a");
  a.setAttribute('download', '');
  a.setAttribute('href', url);
  var b = document.body;

  b.appendChild(a);
  a.click();
  setTimeout(() => {
    b.removeChild(a);
  }, 100)
}

/**
 * Check for valid URL.
 * @param {String} url URL
 */
export const isValidUrl = (url) => {
  return isURL(url);
}

/**
 * @param {String} email give a email address
 * @returns {String} return domain name based on given email.
 */
export const getDomainName = (email) => {
  return email.replace(/.*@/, "");
}
/**
 * A bottom sheet's Escape, taken on window first so a dialog the sheet sits in does not close too.
 * @param {Function} close - Closes the sheet
 * @returns {Function} `(isListening)` → adds or removes the window listener
 */
export const sheetEscapeListener = (close) => {
  const closeOnEscape = (e) => {
    if (e.key === 'Escape') {
      e.stopPropagation();
      close();
    }
  };
  return (isListening) => window[isListening ? 'addEventListener' : 'removeEventListener']('keydown', closeOnEscape, { capture: true });
};

// A touchpad gesture ends once wheel events stop for this long (ms): browsers send no "fingers lifted" event.
export const TOUCHPAD_SWIPE_END_DELAY = 200;

// A touch starting this close to the screen's left edge is the iOS app's back swipe (edge-swipe-back-mixin); kerika-carousel releases the same strip.
export const EDGE_SWIPE_PX = 20;

/**
 * @param {Event} event A wheel or pointer event.
 * @param {Element} boundary Search stops at this element (not checked itself).
 * @returns {Boolean} `true` when the event started inside content that scrolls sideways, e.g. a wide table or code block.
 */
export const isInHorizontalScroller = (event, boundary) => {
  for (const node of event.composedPath()) {
    if (node === boundary) {
      return false;
    }
    if (node.nodeType === Node.ELEMENT_NODE && node.scrollWidth > node.clientWidth
      && ['auto', 'scroll'].includes(node.ownerDocument.defaultView.getComputedStyle(node).overflowX)) {
      return true;
    }
  }
  return false;
}
